module.exports = __webpack_public_path__ + "img/virtual-lift.89635324.svg";